import { FieldBuilder } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');
const OTHERUSEINCONSISTENCYONLYINGIS_STAND_FIELD = FieldBuilder
  .text('name', 'Entity.Stand')
  .readOnly()
  .build();

FieldBuilder.setNamespace('Geographic');
export const OTHERUSEINCONSISTENCYONLYINGIS_FIELDS = [
  OTHERUSEINCONSISTENCYONLYINGIS_STAND_FIELD,
  FieldBuilder.number('area', 'Entity.OtherUseInconsistency.Area').decimal().readOnly().build(),
  FieldBuilder.text('soilUse', 'Entity.OtherUseInconsistency.SoilUse').readOnly().build(),
  FieldBuilder.text('conservationType', 'Entity.OtherUseInconsistency.ConservationType').readOnly().build(),
];

export const OTHERUSEINCONSISTENCYONLYINGIS_CONFIG = {
  entityName: 'OtherUseInconsistencyOnlyInGis',
  localizationKey: 'Geographic::Entity.GisInconsistencyGroupCard.OtherUsesOnlyInGis',
  fields: OTHERUSEINCONSISTENCYONLYINGIS_FIELDS,
  permission: 'PlanningLocation.OtherUses',
  showInMenu: false,
};
